import { ITabElement } from 'ui/components/Tabs/types';

export const adminsTabElements: ITabElement[] = [
  { title: 'Administrators', component: () => <></> },
  { title: 'Invitations', component: () => <></> },
];
